import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useNavigate } from "react-router-dom";
import blogData from "../../_data/blogData";
import useFadeInOnScroll from "../../components/Effects/FadeInOnScroll";

gsap.registerPlugin(ScrollTrigger);

const BlogsPage = () => {
    useFadeInOnScroll();
    const navigate = useNavigate();

    return (
        <div className="padding-container py-5 my-5 flex flex-col gap-5">
            <div className="h-[50px]"></div>
            <h1 className="w-full text-center text-2xl md:text-3xl lg:text-4xl uppercase font-bold ">Insights</h1>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                {blogData.map((blog, i) => (
                    // <div
                    //     key={blog.id}
                    //     className="border rounded-lg overflow-hidden cursor-pointer"
                    //     onClick={() => navigate(`/blogs/${blog.slug}`)}
                    // >
                    //     <img src={blog.image} alt={blog.alt || blog.title} className="w-full h-48 object-cover" />
                    //     <div className="p-4">
                    //         <h2 className="text-xl font-bold mb-2">{blog.title}</h2>
                    //         <p className="text-gray-600">{blog.description}</p>
                    //     </div>
                    // </div>
                    <div
                        key={blog.id}
                        className={`cursor-pointer flex-shrink-0`}
                        onClick={() => navigate(`/blogs/${blog.slug}`)}
                    >
                        <div
                            className="relative w-full h-[350px] rounded-xl flex flex-col justify-end"
                            style={{ backgroundImage: `url("${blog.image}")`, backgroundSize: "cover", backgroundPosition: "center" }}
                        >
                            <div className="absolute w-full h-full rounded-xl" style={{ background: "linear-gradient(180deg, #FFFFFF 0%, #000000 100%)", mixBlendMode: "multiply" }}></div>
                            <div className="absolute w-full h-full rounded-xl flex flex-col p-4 justify-end" style={{ zIndex: 1 }}>
                                <div className="font-bold uppercase">{blog.title}</div>
                                <div className="text-xs text-[var(--l-gray)]">{blog.description}</div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default BlogsPage;